import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import discountImg from "../../assets/vactor-images/discount.svg";
import { NavLink } from "react-router-dom";
import { titleToUrl } from "./../../shared/extra";
import { Tooltip, Typography } from "@mui/material";
import { isDiscountedProduct } from "../../hooks/utilsFn/utilsFn";

const PopularGiftCard = ({ productData }) => {
  const { productType, discount } = isDiscountedProduct(productData?.discount, productData?.cashback_amount);
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        width: { sm: 130, md: 165, lg: 160, xl: 165 },
        height: { sm: 132, md: 163, lg: 167, xl: 167 },
        py: { xs: 0, md: 0, lg: 0 },
        px: { xs: 0, md: 0, lg: 0 },
        borderRadius: {
          xs: 6,
          md: 6,
          lg: 6
        },
        mx: "3px",
        mb: 1,
        position: "relative",
        border: { sm: "1px solid #deebff", md: "2px solid #deebff" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >

        <CardMedia
          component="img"
          sx={{
            width: { sm: "100%", md: "100%", lg: "100%", xl: "100%" },
            height: { sm: 80, md: "100px", lg: "103px", xl: "103px" },
            borderRadius: 0,
            objectFit: { sm: "cover", md: "contain" },
            boxShadow: { sm: 0, md: 0, lg: 0 },
            mixBlendMode: "multiply"
          }}
          image={productData?.image}
          alt={productData?.title}
          loading="lazy"
        />

        <Box
          component="div"
          sx={{
            position: "absolute",
            bottom: {
              sm: "calc(100% - 87px)",
              md: "53px",
              lg: "53px",
              xl: "48px"
            },
            left: "50%",
            transform: "translateX(-50%)",
            background: `transparent url(${discountImg}) center center/auto no-repeat`,
            py: "3px",
            textAlign: "center",
          }}
        >
          <Typography
            variant="subtitle1"
            component="div"
            sx={{
              color: "#fff",
              fontWeight: 400,
              fontSize: { xs: 10, lg: 10, xl: 12 },
              px: "2px",
              width: "180px",
            }}
          >
            {`${productType}`} :
            <Typography
              variant="subtitle1"
              component="span"
              sx={{
                color: "white.main",
                fontWeight: 400,
                fontSize: 12,
                ml: "3px"
              }}
            >
              {`${discount}%`}
            </Typography>
          </Typography>
        </Box>



        <CardContent
          sx={{
            height: {
              sm: "calc(142px - 88px)",
              md: "calc(163px - 100px)",
              xl: "calc(166px - 93px)",
            },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            flex: "1 0 auto",
            width: "100%",
            px: {
              sm: 0,
              md: 0,
              lg: 0,
              xl: 0
            },
            pt: {
              sm: 0,
              md: 0,
              lg: 0,
              xl: 0
            },
            pb: {
              sm: "0 !important"
            }
          }}
        >

          <Tooltip title={productData?.title} >
            <NavLink
              to={`/card-details/${productData?.id}/${titleToUrl(productData?.title)}`}
              style={{ textDecoration: "none" }}
            >
              <Typography
                component="div"
                variant="h5"
                sx={{
                  color: "#000312",
                  fontWeight: { sm: 400, md: 400, lg: 400 },
                  fontSize: { sm: "10.5px", md: "13.5px", lg: "13.5px" },
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  wordWrap: "break-all",
                  wordBreak: "break-word",
                  cursor: "pointer",
                  textAlign: "center",
                  px: { sm: 1, md: 0 },
                }}
              >
                {productData?.title}
              </Typography>
            </NavLink>
          </Tooltip>
        </CardContent>
      </Box>
    </Card>
  );
};

PopularGiftCard.propTypes = {
  productData: PropTypes.object.isRequired,
};

export default PopularGiftCard;
